import { render, staticRenderFns } from "./CreateRuleMain.vue?vue&type=template&id=1fabbf3c&scoped=true"
import script from "./CreateRuleMain.vue?vue&type=script&lang=js"
export * from "./CreateRuleMain.vue?vue&type=script&lang=js"
import style0 from "./CreateRuleMain.vue?vue&type=style&index=0&id=1fabbf3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fabbf3c",
  null
  
)

export default component.exports